<template>
  <div id="app">
    <div id="main-container">
      <header>
        <nav
          class="navbar is-info"
          role="navigation"
          aria-label="main navigation"
        >
          <div class="navbar-brand">
            <a href="/">
              <img
                src="./assets/gruppofma.png"
                style="margin: 8px 10px 2px; height: 36px"
              />
            </a>

            <a
              role="button"
              class="navbar-burger burger"
              aria-label="menu"
              aria-expanded="false"
              data-target="mainNavbar"
              v-on:click="isActive = !isActive"
              :class="{ 'is-active': isActive }"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div
            id="mainNavbar"
            class="navbar-menu"
            :class="{ 'is-active': isActive }"
          >
            <div class="navbar-start" v-if="$ajax.getUser().valueOf()">
              <router-link to="/" class="navbar-item" exact>Home</router-link>
              <router-link
                to="/users"
                class="navbar-item"
                v-if="$ajax.getUserRole().userView"
                >Utenza</router-link
              >
              <router-link
                to="/sales-points"
                class="navbar-item"
                v-if="
                  $ajax.getUserRole().salePointView ||
                  $ajax.getUserRole().salePointViewAll
                "
                >Sale Points</router-link
              >
              <router-link to="/cards" class="navbar-item">Schede</router-link>
            </div>
            <div class="navbar-end">
              <router-link to="/login" class="navbar-item login">
                <b-icon icon="user" v-if="$ajax.getUser().valueOf()"></b-icon>
                <span v-else>Login</span>
              </router-link>
            </div>
          </div>
        </nav>
      </header>

      <!--
    <div class="breadcrumb is-centered">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <a href="#">Dashboard</a>
          </li>

          <li v-if="this.$route.name == 'user' || this.$route.name == 'user-products'">
            <router-link :to="`/user/${this.$route.params.id}`">
              <a>Nome utente</a>
            </router-link>
          </li>

          <li v-if="this.$route.name == 'user-products'">
            <router-link :to="`/user/${this.$route.params.id}/products`">
              <a>Prodotti</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
      -->
      <!--<pre class="has-text-left">{{this.$route}}</pre>-->
      <div class="container">
        <!--<keep-alive exclude="user,product-edit">
        </keep-alive>-->
        <router-view />
      </div>
    </div>

    <footer class="footer is-size-7">
      <div class="container has-text-left">
        <div>
          <ul>
            <li>
              UI <code>{{ version }}</code>
            </li>
            <!--
            <li v-if="this.serverStatus.serverVersion">
              Srv:
              <code>
                <span>{{ this.serverStatus.serverVersion.major }}</span>
                <span>.{{ this.serverStatus.serverVersion.minor }}</span>
                <span>.{{ this.serverStatus.serverVersion.build }}</span>
                <span>.{{ this.serverStatus.serverVersion.revision }}</span>
              </code>
            </li>
            <li v-if="false && this.serverStatus.canConnect !== undefined">
              DB:
              <b
                :class="
                  this.serverStatus.canConnect
                    ? 'has-text-success'
                    : 'has-text-danger'
                "
                >{{ this.serverStatus.canConnect ? "OK" : "ERROR" }}</b
              >
            </li>
            -->
          </ul>
        </div>
      </div>
    </footer>
    <div
      class="content has-text-right is-size-7"
      style="background-color: #fafafa"
    >
      <b-icon pack="fas" icon="code" size="is-small"></b-icon>&nbsp;with
      <b-icon pack="fas" icon="heart" size="is-small" type="is-danger"></b-icon>
    </div>
  </div>
</template>

<script>
import { version } from "../package.json";

export default {
  name: "app",
  components: {},
  data() {
    return { isActive: false, serverStatus: {} };
  },
  mounted() {
    this.$ajax.request({
      address: "/about/",
      silent: true,
      method: "GET",
      onSuccess: (response) => {
        this.serverStatus = response.data;
      },
    });
  },
  computed: {
    version() {
      return version;
    },
  },
};
</script>

<style>
header {
  margin-bottom: 3rem;
}
</style>
